<template>
    <div class="container">
        <van-nav-bar
            leftText
            :leftArrow="isBack"
            @click-left="backGo"
            title="购物车"
            class="headerbar cart-title"
        >
            <van-button
                v-if="cartCount"
                slot="right"
                class="btn btn-text"
                @click="onEditClick"
            >{{cartText}}</van-button>
        </van-nav-bar>
        <div class="topbar-container list">
            <div class="noMessage" v-if="!cartCount">
                <div class="bv bc message-content">
                    <div class="img"></div>
                    <div class="empty fz_24">购物车空空如也~</div>
                    <div class="empty-text fz_24" @click="onShopClick">赶快去选购商品吧</div>
                </div>
            </div>
            <div v-if="cartCount" class="buy-container buy-list">
                <div class="scrollbar-container">
                    <div class="line"></div>
                    <div class="bh bstart group-title" @click="onListClick(isCheckedAll)">
                        <span @click.stop>
                            <van-checkbox v-model="isCheckedAll"></van-checkbox>
                        </span>
                        <div class="bg-contain ico-good"></div>
                        <div class="fz_34">车主用品</div>
                        <div class="bg-contain ico-next"></div>
                    </div>
                    <div v-for="(item,index) in cartList" :key="index" class="cart-list-item">
                        <div
                            class="item bh bstart"
                            v-on:click="onInfoClick(item)"
                            v-if="item.goodsVM"
                        >
                            <!-- 外面包一层容器来阻止点击事件冒泡 -->
                            <span @click.stop>
                                <van-checkbox v-model="item.checked"></van-checkbox>
                            </span>
                            <div
                                class="img bg-100 r6"
                                :style="{backgroundImage: 'url(' + item.goodsVM.smallPic + ')'}"
                            ></div>
                            <div class="item-content b1 bv">
                                <div class="fz_30 w_100 title overflow2 breakword">{{item.goodsVM.name}}</div>
                                <div class="mt_10 c_warning fz_30 bh bstart">
                                    <div class="bg-contain ico-maintenance"></div>
                                    <span class="c_red">{{item.goodsVM.price}}</span>
                                </div>
                                <div class="bv bendend b1 number">
                                    <div @click.stop>
                                        <van-stepper
                                            v-model="item.goodsQuantity"
                                            default-value="1"
                                            min="1"
                                            :max="item.goodsVM.perBuyAmount"
                                            @change="onNumChange($event,item)"
                                            integer
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="buybar bh bstart">
                    <div class="b1 fz_28 text bh bstart" :class="isEdit?'hidden':''">
                        合计：
                        &nbsp;
                        <span
                            class="c_red fz_40"
                        >{{totalPrice}}&nbsp;</span> 车主币
                    </div>
                    <van-button
                        class="btn btn-goodbuy"
                        v-if="!isEdit"
                        :disabled="isDisabled"
                        @click="onBuyClick"
                    >
                        <span class="fz_28">结算</span>
                    </van-button>
                    <van-button
                        class="btn btn-goodbuy"
                        :disabled="isDisabled"
                        @click="onDelClick"
                        v-if="isEdit"
                    >
                        <span class="fz_28">删除</span>
                    </van-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { user } from "@/mixin/user";
import { cartDel, cartUpdate } from "@/api/cart";
import util from "@/utils/index";
export default {
    mixins: [user],
    name: "CartHome",
    props: {
        // 是否显示返回按钮
        isBack: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            // 是否编辑
            isEdit: false,
            // 是否选中所有商品
            isCheckedAll: false,
            // 是否手动点击勾选
            isCheckedIng: false,
            // 是否正在更新购物车数据
            isChange: false
        };
    },
    computed: {
        isDisabled() {
            return this.isChange || !this.totalPrice;
        },
        // 总价
        totalPrice() {
            let total = 0;
            this.checkList.forEach(item => {
                total += item.goodsQuantity * item.goodsVM.price;
            });
            if (total) {
                total = total.toFixed(2);
            }
            return total;
        },
        // 当前选中商品
        checkList() {
            return this.cartList.filter(item => {
                return item.checked;
            });
        },
        // 购物车
        cartList() {
            return this.$store.state.cart.cartList;
        },
        // 购物车数量
        cartCount() {
            return this.$store.getters["cart/cartCount"];
        },
        // 状态文字
        cartText() {
            return this.isEdit ? "完成" : "编辑";
        }
    },
    watch: {
        // 单个商品勾选状态改变
        checkList(list) {
            const me = this;
            let is = false;
            if (list.length == me.cartList.length) {
                is = true;
            }
            // 设置是否选中全部
            me.isCheckedAll = is;
            // 标识isCheckedAll不处理逻辑
            me.isCheckedIng = true;
            setTimeout(() => {
                // 延时执行重置标识
                me.isCheckedIng = false;
            }, 100);
            // console.log("checkList");
        },
        // 是否勾选所有值改变
        isCheckedAll(v) {
            // console.log("isCheckedAll");
            if (!this.isCheckedIng) {
                this.cartList.forEach(item => {
                    item.checked = v;
                });
            }
        }
    },
    methods: {
        // 结算
        onBuyClick() {
            this.$router.push({
                name: "CartOrderConfirm",
                params: {
                    isCart: true,
                    orderType: "0",
                    confirmList: this.checkList
                }
            });
        },
        // 改变编辑状态
        onEditClick() {
            this.isEdit = !this.isEdit;
        },
        // 改变所有选中状态
        onListClick(v) {
            this.isCheckedAll = !v;
        },
        // 改变单个商品选中状态
        onInfoClick(item) {
            item.checked = !item.checked;
        },
        // 改变数量
        onNumChange(v, item) {
            this.isChange = true;
            // 函数防抖
            util.debounce(this.numberChange, { v, item });
        },
        // 改变数量
        numberChange({ v, item }) {
            cartUpdate(item.id, {
                goodsId: item.goodsVM.id,
                goodsQuantity: v
            }).then(() => {
                this.isChange = false;
            });
        },
        // 点击删除
        onDelClick() {
            const me = this;
            me.dialog
                .confirm({
                    title: "提示",
                    message: "确认将所勾选商品删除？"
                })
                .then(() => {
                    const list = [];
                    me.checkList.forEach(item => {
                        list.push(item.id);
                    });
                    cartDel(list.toString()).then(res => {
                        me.$store.dispatch("cart/cartList", true);
                    });
                });
        },
        // 获取用户数据后执行
        userLoginend() {
            this.$store.dispatch("cart/cartList");
        },
        // 跳转到商品页
        onShopClick() {
            this.$router.push({
                name: "CarGoodsHome",
                // 用于清空参数
                params: {
                    id: ""
                }
            });
        }
    }
};
</script>
<style scoped lang="scss">
.cart-header {
    /deep/.van-nav-bar__title {
        margin: 0 30px 0 325px;
        max-width: 100%;
    }
}
.cart-title {
    .btn-text {
        font-size: 30px;
        color: #666;
    }
}

.topbar-container {
    background: #f7f8f8;
}
.cart-list-item {
    &:last-child {
        .item {
            border-bottom: 0;
        }
    }
}
.buybar {
    .btn {
        margin-right: 30px;
        width: 180px;
    }
}
.noMessage {
    .img {
        width: 100px;
        height: 81px;
        background-image: url("~@/assets/imges/ico/buy.png");
    }
    .empty {
        padding-top: 45px;
        color: #666666;
    }
    .empty-text {
        padding-top: 10px;
        color: #ff9a2b;
    }
}
[data-theme="app"] {
    .noMessage {
        .empty-text {
            color: #c30d23;
        }
    }
}
</style>
